import styled from 'styled-components';
import { ReactComponent as RawAnomalySVG } from '../../../../assets/icons/icon_anomaly.svg';

export const IconAnomaly = styled(RawAnomalySVG)``;
